import { createSelector } from 'reselect'
import at from 'lodash/at'
import get from 'lodash/get'

const getWorkOrders = (state, props) => state.workOrders
const getWorkOrderId = (state, props) => props.params.workOrderId

export const getWorkOrderById = createSelector(
  [getWorkOrders, getWorkOrderId],
  (workOrders, workOrderId) => workOrders[workOrderId]
)

const getAreas = (state, props) => state.areas

const getAreasForLocation = (state, props) => {
  const search = state.areas.currentSearch || ''

  return get(state, `pagination.areasByLocation.${props.locationId}-${search}`, {}).ids
}

export const getAreasBySearch = createSelector(
  [getAreas, getAreasForLocation],
  (areas, areasForLocation) => at(areas, areasForLocation || [])
)



// WEBPACK FOOTER //
// ./src/selectors/area-selectors.js